import { useEffect, useState } from "react";
import decor3 from "../../images/decoration/Group-31.png";
import decor4 from "../../images/decoration/Path-25.png";
import main from "../../images/15.png";
import "./Intro.css";
import { useGetHomeDetailsQuery } from "../../Api/api";
import { useGetSocialMediaQuery } from "../../Api/api";

const Intro = () => {
  return (
    <>
      <section className=" intro-page" id="home">
        <div className="decorations">
          <div className="decor-dot2">
            <img src={decor3} alt="" />
          </div>

          <div className="parcol"></div>
        </div>
        <div className="small-intro">
          <div className="intro-row">
            <div className="col-lg-5  col-md-6 col-sm-12 intro-left">
              <div className="intro-name">
                <h3
                  className="hello"
                  data-aos="fade-down"
                  data-aos-duration="1500"
                >
                  Software Developer
                </h3>
                <h3
                  className="name"
                  data-aos="fade-down"
                  data-aos-duration="1600"
                >
                  Hey! I Am
                </h3>
                <h3
                  className="job  text-animate"
                  data-aos="fade-down"
                  data-aos-duration="1700"
                >
                  Daya Ram
                </h3>
                <p
                  className="myinfo"
                  data-aos="fade-down"
                  data-aos-duration="1800"
                >
                  Am I Software developer passionate and experience in building
                  web applications
                </p>
              </div>
              <div
                className="intro-btns"
                data-aos="fade-up"
                data-aos-duration="1900"
              >
                <a
                  href="https://www.fiverr.com/dayaram48"
                  className="contactMe"
                >
                  <button className="contact-me">
                    Hire me <i class="bx bx-send "></i>
                  </button>
                </a>
              </div>
              <div
                class="intro-contact"
                data-aos="fade-up"
                data-aos-duration="1800"
              >
                <span>Follow Me:</span>
                <ul>
                  <li>
                    <a
                      className="icon-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      
                      {/* facebook */}
                      <a
                        className="icon-link"
                        target="_blank"
                        href="https://www.facebook.com/Dayarammania"
                      >
                       <i className="bx bxl-facebook"></i>
                      </a>
                      
                      {/* whatsapp */}
                      <a
                        className="icon-link"
                        target="_blank"
                        href="https://wa.me/+923436790664"
                      >
                        <i className="bx bxl-whatsapp"></i>
                      </a>

                      
                      {/* instagram */}
                      <a
                        className="icon-link"
                        target="_blank"
                        href="https://www.instagram.com/daya_ram_dev"
                      >
                         <i className="fa fa-instagram"></i>
                      </a>


                     {/* linkedin */}
                      <a
                        className="icon-link"
                        target="_blank"
                        href="https://www.linkedin.com/in/daya-ram"
                      >
                        {" "}
                        <i className="bx bxl-linkedin" />
                      </a>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className="col-lg-7 col-md-6 col-sm-12 left-img "
              data-aos="fade-down-left"
            >
              <div className="ff">
                <img className="intro-img" src={main} alt="" />
                {/* <img
                      className="intro-img"
                      src={`${img_300}${detail.avatar_img}`}
                      alt=""
                    /> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Intro;
